import React from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { DoctorsList } from '../components/features/DoctorsList';

export const DoctorsPage: React.FC = () => {
  return (
    <AppLayout title="Врачи">
      <DoctorsList />
    </AppLayout>
  );
};
